import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ResultadoSection() {
  const benefits = ['Ingresos más estables', 'Más claridad en tu negocio', 'Más control sobre tus resultados', 'Clientes de mejor calidad', 'Más tiempo con tu familia'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-169">
      <div className="max-w-6xl mx-auto" data-id="element-170">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-171">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.3
        }} className="flex-1 text-center lg:text-left" data-id="element-172">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-black mb-6" data-id="element-173">
              El resultado que vas a lograr
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-174">
              No se trata solo de facturar más, se trata de construir un negocio
              que no dependa de que estés apagando incendios todo el día.
            </p>

            <div className="bg-brand-orange/10 border border-brand-orange/20 rounded-3xl p-8 mb-8 inline-block" data-id="element-175">
              <p className="text-sm font-bold text-brand-orange uppercase tracking-wider mb-2" data-id="element-176">
                Objetivo del programa
              </p>
              <p className="text-5xl md:text-6xl font-heading font-extrabold text-brand-black" data-id="element-177">
                $800.000{' '}
                <span className="text-2xl md:text-3xl text-gray-500 font-medium" data-id="element-178">
                  ARS/mes
                </span>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.3,
          delay: 0.1
        }} className="flex-1 w-full" data-id="element-179">
            <div className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-100" data-id="element-180">
              <ul className="space-y-6" data-id="element-181">
                {benefits.map((benefit, index) => <motion.li key={index} initial={{
                opacity: 0,
                y: 8
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.2,
                delay: 0.15 + index * 0.06
              }} className="flex items-center gap-4" data-id="element-182">
                    <div className="bg-brand-orange rounded-full p-1 shrink-0" data-id="element-183">
                      <Check className="w-5 h-5 text-brand-black" data-id="element-184" />
                    </div>
                    <span className="text-xl font-medium text-brand-black" data-id="element-185">
                      {benefit}
                    </span>
                  </motion.li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-16" data-id="element-186">
          <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center" data-id="element-187">
            Quiero estos resultados
          </a>
          <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-brand-black font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-188">
            Consultar ahora
          </a>
        </motion.div>
      </div>
    </section>;
}